import { PropsWithChildren } from 'react';

import { ClientTokenAuthentication } from '@flipt-io/flipt';
import { FliptProvider } from '@flipt-io/flipt-client-react';

import { appEnv } from '@/app/config/env';

type FeaturesFlags =
  | 'Attached-File-To-Script-Generation'
  | 'Publication-Integration-BS'
  | 'Regenerate-Script';

const client = new ClientTokenAuthentication(appEnv.fliptToken);

const FeatureFlagsProvider = ({ children }: PropsWithChildren) => {
  return (
    <FliptProvider
      options={{
        url: appEnv.fliptUrl,
        namespace: appEnv.fliptNamespace,
        authentication: client,
      }}
    >
      {children}
    </FliptProvider>
  );
};

export { FeatureFlagsProvider, type FeaturesFlags };
